export { default as planoVelesReducer } from './planoVeles-slice'
export * from './planoVeles-slice'
